import { useBrowserOnlyInjectSaga } from '@dbh/redux-extra';
import { i as injectedSagaConfiguration, u as userAreaRootSaga } from './index-7db3fb86.js';

const injectSagaOptions=Object.freeze({...injectedSagaConfiguration,saga: userAreaRootSaga}),useBrowserOnlyUserAreaSaga=()=>useBrowserOnlyInjectSaga(injectSagaOptions);var useBrowserOnlyUserAreaSaga$1 = useBrowserOnlyUserAreaSaga;

export { useBrowserOnlyUserAreaSaga$1 as u };
